export default class AuthorityHelper {
  constructor(ctx) {
    this.ctx = ctx
  }

  hasRoleAdmin()
  {
    var user=this.ctx.$store.getters.user;

    if (user!=null)
    {
      return user.roles.includes("ROLE_ADMIN");
      //let obj = user.authorities.find(o => o.authority === 'ROLE_ADMIN');
      //return !(obj === undefined)
    }
    else
      return false;
  }

  hasRolePulverlagerListe()
  {
    var user=this.ctx.$store.getters.user;
    if (user!=null)
    {
      return user.roles.includes("ROLE_PULVERLAGERLISTE");
      //return user.authorities.includes("ROLE_PULVERLAGERLISTE");
    }
    else
      return false;
  }

}
